<template>
  <nav-bar title="地图" />
  <Content :bottom="0">
    <div class="bmap" ref="bmap"></div>
    <div class="search-btn">
      <div class="search-btn-text" @click="search.showPopup()">客户搜索</div>
    </div>
  </Content>
  <Search ref="search" />
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import { getCustomerMap } from '@/api/customer'
import { useGetData } from '@/hooks/useGetData'
import { useWxConfig } from '@/utils/wxConfig'
import { useStore } from 'vuex'
import BMapGL from 'BMapGL'
import Search from './Search.vue'
import { useRouter } from 'vue-router'
export default {
  name: 'OpenMap',
  components: { Search },
  setup() {
    const mapvgl = require('mapvgl')
    const value = ref('')
    const router = useRouter()
    // 获取基本信息
    const totalInfo = ref({})
    const custPoint = ref([])
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const departId = computed(() => store.state.roleInfo.departId)
    const roleId = computed(() => store.state.roleInfo.roleId)

    const tenantId = localStorage.getItem('tenant_id')

    const longitude = localStorage.getItem('tenant_longitude')
    const latitude = localStorage.getItem('tenant_latitude')

    // 获取微信定位
    const { getLocation } = useWxConfig() // 获取jssdk配置
    const bmap = ref(null)
    let map = null
    onMounted(() => {
      // 1.初始化
      map = new BMapGL.Map(bmap.value)
      var point = new BMapGL.Point(longitude || 115.985371, latitude || 36.456703) // 创建点坐标
      map.centerAndZoom(point, 10) // 初始化地图，设置中心点坐标和地图级别
      map.enableScrollWheelZoom(true)
      const zoomCtrl = new BMapGL.ZoomControl() // 添加缩放控件
      map.addControl(zoomCtrl)
      const locationCtrl = new BMapGL.LocationControl() // 添加定位控件
      map.addControl(locationCtrl)
      getLocation(res => {
        if (res) {
          var convertor = new BMapGL.Convertor()
          var pointArr = []
          point = new BMapGL.Point(res.longitude, res.latitude) // 创建点坐标
          pointArr.push(point)
          convertor.translate(pointArr, 1, 5, data => {
            point = data.points[0]
            map.centerAndZoom(point, 10)
          })
        }
      })
      // 2.定位
      // const myCity = new BMapGL.LocalCity()
      // myCity.get(result => {
      //   const cityName = result.name
      //   map.setCenter(cityName)
      // })
      // 3.创建MapVGL图层管理器
      const view = new mapvgl.View({
        map: map
      })
      // 4. 创建可视化图层，并添加到图层管理器中
      const layer = new mapvgl.ClusterLayer({
        size: 16,
        minSize: 30, // 聚合点显示的最小直径
        maxSize: 50, // 聚合点显示的最大直径
        clusterRadius: 150, // 聚合范围半径
        gradient: { 0: '#1296db', 0.5: '#1296db', 1.0: '#1296db' }, // 聚合点颜色梯度
        maxZoom: 15, // 聚合的最大级别，当地图放大级别高于此值将不再聚合
        minZoom: 5, // 聚合的最小级别，当地图放大级别低于此值将不再聚合
        // 是否显示文字
        showText: true,
        // 开始聚合的最少点数，点数多于此值才会被聚合
        minPoints: 5,
        // 设置文字样式
        textOptions: {
          fontSize: 12,
          color: 'white'
          // 格式化数字显示
          // format: function (count) {
          //   return count >= 10000 ? Math.round(count / 1000) + 'k'
          //     : count >= 1000 ? Math.round(count / 100) / 10 + 'k' : count
          // }
        },
        // 设置非聚合的点的icon
        // iconOptions: {
        //     width: 100 / 4,
        //     height: 153 / 4,
        //     icon: 'images/marker.png',
        // },
        enablePicked: true,
        onClick(e) {
          if (e.dataItem) {
            // 可通过dataItem下面的children属性拿到被聚合的所有点
            const { children, properties } = e.dataItem
            if (!children) {
              const { status, userId } = properties
              if (status !== '01') {
                router.push(`/developUsers/${userId}`)
              } else {
                router.push(`/userInfo/${userId}`)
              }
            }
          }
        }
      })
      view.addLayer(layer)

      var textLayer = new mapvgl.TextLayer({
        color: '#000',
        fontFamily: 'Microsoft Yahei',
        fontSize: 10,
        flat: true,
        collides: true,
        offset: [0, -20],
        padding: [2, 2],
        margin: [0, 0]
      })

      // 5. 准备好规范化坐标数据
      useGetData(getCustomerMap, data => {
        totalInfo.value = data
        if (totalInfo.value.list) {
          totalInfo.value.list.forEach(item => {
            // 创建点坐标
            var point = {
              geometry: {
                type: 'Point',
                coordinates: [item.longitude, item.latitude]
              },
              properties: {
                text: item.companyName, // 展示的文字
                userId: item.userId,
                icon: require(item.userStatus === '01'
                  ? '../../image/map-zs.png'
                  : '../../image/map-tz.png'),
                width: 25,
                height: 25,
                status: item.userStatus
              }
            }
            custPoint.value.push(point)
          })
          // 6. 关联图层与数据，享受震撼的可视化效果
          layer.setData(custPoint.value)
          textLayer.setData(custPoint.value)
        }
      })({
        companyId: companyId.value || '',
        deptId: departId.value || '',
        roleId: roleId.value || '',
        tenantId: tenantId || ''
      })

      view.addLayer(textLayer)
    })
    const search = ref(null)
    return {
      bmap,
      value,
      totalInfo,
      custPoint,
      search,
      longitude,
      latitude
    }
  }
}
</script>

<style lang="scss" scoped>
.bmap {
  height: calc(100vh - 116px);
}
.search-btn {
  background-color: #fff;
  padding: 16px;
  &-text {
    background-color: #f8f8f8;
    font-size: 14px;
    text-align: center;
    padding: 10px 5px;
    color: #666;
  }
}
</style>
